import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';
import { Button } from '../../../components/ui/index.jsx';
import { useToast } from '../../../components/ui/Toast.jsx';

const NotificationTab = () => {
    const toast = useToast();
    const [originalNotificationSettings, setOriginalNotificationSettings] = useState({});
    const [notificationSettings, setNotificationSettings] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const global = window.BPSFW_GLOBAL_OPTIONS || {};
        setNotificationSettings(global);
        setOriginalNotificationSettings(global);
    }, []);

    const handleSave = () => {
        const changedData = Object.fromEntries(
            Object.entries(notificationSettings).filter(([key, value]) => originalNotificationSettings[key] !== value)
        );
        if (Object.keys(changedData).length === 0) {
            toast.info('No changes detected.');
            return;
        }
        setLoading(true);
        apiFetch({ path: '/wp/v2/settings', method: 'POST', data: changedData })
            .then(() => {
                toast.success('Notification settings saved!');
                window.BPSFW_GLOBAL_OPTIONS = { ...(window.BPSFW_GLOBAL_OPTIONS || {}), ...notificationSettings };
                setOriginalNotificationSettings(notificationSettings);
            })
            .catch((err) => {
                console.error('Error saving notification settings:', err);
                toast.error('Error saving notification settings.');
            })
            .finally(() => setLoading(false));
    };

    const updateNotificationSetting = (key, value) => {
        setNotificationSettings({ ...notificationSettings, [key]: value });
    };

    return (
        <div className="plugin-notification-setting-tab">
            {loading && (
                <div className="bpsfw-overlay-loader">
                    <div className="bpsfw-loader-box">
                        <div className="bpsfw-spinner"></div>
                        <span className="bpsfw-loader-text">Saving changes…</span>
                    </div>
                </div>
            )}

            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">🔔</div>
                    <div>
                        <div className="bpsfw-section-title">User Registration Email Notification</div>
                        <div className="bpsfw-section-subtitle">Send alerts when new users register</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    {renderInputRow(
                        'Enable Notification',
                        'bpsfw_user_regi_email_notification',
                        'checkBox', [],
                        'Send email notification when a new user registers',
                        '', notificationSettings, updateNotificationSetting
                    )}
                    {renderInputRow(
                        'Recipient Email(s)',
                        'bpsfw_user_regi_email',
                        '', [], '', '', notificationSettings, updateNotificationSetting,
                        <p className="description">Separate multiple addresses with a comma and space: e.g. <code>admin@site.com, team@site.com</code></p>
                    )}
                    {renderInputRow(
                        'Email Subject',
                        'bpsfw_user_regi_email_subject',
                        '', [], '', '', notificationSettings, updateNotificationSetting,
                        <p className="description">Subject line for the registration notification email</p>
                    )}
                    {renderInputRow(
                        'Email Message',
                        'bpsfw_user_regi_email_msg',
                        'textArea', [], '', '', notificationSettings, updateNotificationSetting,
                        <><p className="description">{`Use `}<code>{'{customer_name}'}</code>{` to include customer name in the email.`}</p></>
                    )}
                </div>
            </div>

            <div className="bpsfw-save-row">
                <Button variant="primary" onClick={handleSave}>Save Changes</Button>
            </div>
        </div>
    );
};

export default NotificationTab;
